import * as React from 'react';
/**
 *
 * Original name: OnlyFans
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=22733%3A2870
 *
 */
export const OnlyFansExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M21.503 6H18.49c-2.588 0-3.977.148-5.063 1.469a6 6 0 1 0 1.578 6.911c2.388-.174 4.043-1.602 4.566-3.881 0 0-1.8.438-3.324 0 3.015-.583 4.752-2.28 5.256-4.499Zm-13.8 6a1.794 1.794 0 0 1 2.756-1.521 2.225 2.225 0 0 1 2.248-1.897h.006c-.69 1.334-1.055 2.514-1.498 3.948A1.795 1.795 0 0 1 7.704 12Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
